
import { Component, Vue, Watch } from 'vue-property-decorator';

import {
	productSellCountAnalysisDailyData,
	productSellCountAnalysisDailyDataDetail,
	productSellCountAnalysisDailyCategoryData,
	productSellCountAnalysisDailyCategoryDataDetail
} from "@/api/statistic";
import {
	currentEmployeeRoleInfo
} from '@/api/order';

import {
	getSearchDate,
	nextDay
} from "@/utils"
@Component({
	name: '',
	components: {
	}
})

export default class TodayAnalysis extends Vue {
	private permissions = [];
	private timeStr = '';
	private templateOne = {
		tableData: [],
		keywords: '',
		tableLoading: false
	}
	private templateTwo = {
		tableData: [],
		keywords: '',
		tableLoading: false
	}
	private templateThree = {
		tableData: [],
		keywords: '',
		tableLoading: false
	}
	private templateFour = {
		tableData: [],
		keywords: '',
		tableLoading: false
	}

	private async created(){
		
		await this.getRoleInfo();
		this.reloadData();
	}

	private async getRoleInfo(){
		let res: any = await currentEmployeeRoleInfo({})
		if (res.IsSuccess) {
			this.permissions = res.Result.ProductSellCountAnalysisDailyDataPermissions;
		}
		return
	}

	private getToday(){
		this.timeStr = new Date().toLocaleString();
	}

	private reloadData(){
		this.getToday();
		this.getTemplateOneData();
		this.getTemplateTwoData();
		this.getTemplateThreeData();
		this.getTemplateFourData();
	}

	private async getTemplateOneData(){
		if (!this.permissions.includes(1)) return;
		this.templateOne.tableLoading = true;
		try {
			const res = await productSellCountAnalysisDailyData({
				Keywords: this.templateOne.keywords,
				Skip: 0,
				Take: 996
			})

			this.templateOne.tableData = res.Result.Results;
		} catch (error) {
			
		} finally {
			this.templateOne.tableLoading = false;
		}
	}
	private handleExportTemplateOne(){
		let url = `${location.origin}/pc/dataStatisProductSellAnalysis/productSellCountAnalysisDailyData?Keywords=${this.templateOne.keywords}`;
		window.open(url);
	}


	private async getTemplateTwoData(){
		if (!this.permissions.includes(2)) return;
		this.templateTwo.tableLoading = true;
		try {
			const res = await productSellCountAnalysisDailyDataDetail({
				Keywords: this.templateTwo.keywords,
				Skip: 0,
				Take: 996
			})

			this.templateTwo.tableData = res.Result.Results;
		} catch (error) {
			
		} finally {
			this.templateTwo.tableLoading = false;
		}
	}
	private handleExportTemplateTwo(){
		let url = `${location.origin}/pc/dataStatisProductSellAnalysis/productSellCountAnalysisDailyDataDetail?Keywords=${this.templateTwo.keywords}`;
		window.open(url);
	}


	private async getTemplateThreeData(){
		if (!this.permissions.includes(3)) return;
		this.templateThree.tableLoading = true;
		try {
			const res = await productSellCountAnalysisDailyCategoryData({
				Keywords: this.templateThree.keywords,
				Skip: 0,
				Take: 996
			})

			this.templateThree.tableData = res.Result.Results;
		} catch (error) {
			
		} finally {
			this.templateThree.tableLoading = false;
		}
	}
	private handleExportTemplateThree(){
		let url = `${location.origin}/pc/dataStatisProductSellAnalysis/productSellCountAnalysisDailyCategoryData?Keywords=${this.templateThree.keywords}`;
		window.open(url);
	}


	private async getTemplateFourData(){
		if (!this.permissions.includes(4)) return;
		this.templateFour.tableLoading = true;
		try {
			const res = await productSellCountAnalysisDailyCategoryDataDetail({
				Keywords: this.templateFour.keywords,
				Skip: 0,
				Take: 996
			})

			this.templateFour.tableData = res.Result.Results;
		} catch (error) {
			
		} finally {
			this.templateFour.tableLoading = false;
		}
	}
	private handleExportTemplateFour(){
		let url = `${location.origin}/pc/dataStatisProductSellAnalysis/productSellCountAnalysisDailyCategoryDataDetail?Keywords=${this.templateFour.keywords}`;
		window.open(url);
	}
}
